import React from 'react'

import { IPartyNumberMap } from '../../models/TypeHelper'
import PollNumberSlider from './PollNumberSlider'
import Region from '../../models/Region'
import { IRegionalPollMap } from '../../App'

interface IProps {
  lastReset: number
  regionalPolls: IRegionalPollMap
  handlePollingUpdate: (newPolls: IRegionalPollMap, invalidate: boolean) => void
}

interface IState {
  regionalPolls: IRegionalPollMap
}

export default class RegionalPolls extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props)

    this.state = {
      regionalPolls: props.regionalPolls
    }

    this.handlePollingUpdateFromSlider = this.handlePollingUpdateFromSlider.bind(
      this
    )
  }

  public componentDidUpdate(prevProps: IProps): void {
    if (prevProps.lastReset !== this.props.lastReset) {
      this.setState({ regionalPolls: this.props.regionalPolls })
    }
  }

  public handlePollingUpdateFromSlider(
    regionKey: string,
    newPolls: IPartyNumberMap
  ): void {
    const newRegionalPolls = this.state.regionalPolls
    newRegionalPolls[regionKey] = newPolls
    this.setState({ regionalPolls: newRegionalPolls })
    this.props.handlePollingUpdate(newRegionalPolls, true)
  }

  public render(): JSX.Element {
    const { regionalPolls } = this.state

    const pollInterfaces = Object.keys(regionalPolls).map(
      (regionKey: string): JSX.Element => {
        return (
          <div
            key={regionKey}
            className="row d-flex no-gutters align-items-center"
          >
            <div className="col-12 col-md-2 col-lg-1 text-md-right">
              <h3 className="d-none d-md-block d-xl-none mr-2">
                {Region.fromKey(regionKey).shortName}
              </h3>
              <h3 className="d-md-none d-xl-block mr-2">
                {Region.fromKey(regionKey).name}
              </h3>
            </div>
            <div className="col-12 col-md-10 col-lg-11 pb-2">
              <PollNumberSlider
                compact
                annotations
                resultsWillRandomize
                handlePollingUpdate={(polls: IPartyNumberMap): void => {
                  this.handlePollingUpdateFromSlider(regionKey, polls)
                }}
                polls={this.state.regionalPolls[regionKey]}
              />
            </div>
          </div>
        )
      }
    )

    return <div className="pb-3 mb-1">{pollInterfaces}</div>
  }
}
